<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';

export default {
    data() {
        return {
            form: {
                thing: '',
                type: 'current',
                active: true,
            },
            disableOnSubmit : false,
            dictionary: {
                en: {
                    attributes: {
                        'thing': 'Action'
                    }
                },
            }
        }
    },

    props: ['url', 'journal', 'isEdit', 'getUrl'],

    mixins: [validateAndSubmit, validationClass],

    computed: {
    },

    created() {
    },

    mounted() {
        if(this.isEdit) {
            this.getJournal();
        }
        this.$validator.localize(this.dictionary);
    },

    watch: {
    },

    methods: {
        getJournal() {
            axios
                .get(this.getUrl,
                    {
                        params: {
                        }
                    }
                )
                .then(response => {
                    this.form = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
}
</script>
